module.exports = __webpack_public_path__ + "img/3.dafa72e2.png";